<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Hooks
	import { onMount } from 'svelte';
	//Services
	import { format } from 'svelte-i18n';
	import { zwaveCall } from 'src/services/xz_http_reqs';
	//Stores
	//Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Types
	//Design system components
	import { Button, Radio, Text } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	const inputOptions = ['no_action', 'open', 'close'];
	const _input_options_i18n = [
		$format('alarm_state_no_action', { default: 'No action' }),
		$format('alarm_state_open', { default: 'Open' }),
		$format('alarm_state_close', { default: 'Close' }), //Todo: discuss working types!!!
	];

	let settings = readDeviceSettings(id),
		inputTypes = {},
		deviceChannel = device.channel,
		setting = '92',
		loading = false,
		cache;

	onMount(() => {
		inputTypes[deviceChannel] = settings?.[`Configuration:0`]?.[setting];
		cache = Object.assign({}, { ...inputTypes });
	});

	const setInputType = (value) => {
		inputTypes[deviceChannel] = value;
	};
	const sentRequest = async () => {
		if (JSON.stringify(cache) !== JSON.stringify(inputTypes)) {
			loading = true;

			const res = await zwaveCall(device, {
				cc: 'Configuration',
				m: 'set',
				ep: 0,
				params: [{ parameter: +setting, value: +inputTypes[deviceChannel] }],
			});

			if (res.isok) {
				const res_get = await zwaveCall(device, {
					cc: 'Configuration',
					m: 'get',
					ep: 0,
					params: [+setting],
				});
				cache = Object.assign({}, { ...inputTypes });
			}
			await onSettingsResponse(res, device);
			loading = false;
		}
	};
</script>

<Text element="h2" styleType="body-small" class="mb-s">
	{$format('description_device_action_alarm', {
		default: 'Select device action if alarm was detected.',
	})}
</Text>

{#each inputOptions as option, index}
	<Radio
		size="m"
		selected={inputOptions[inputTypes[deviceChannel]]}
		value={option}
		on:click={() => setInputType(index)}
		id="radio-v660p4u"
	>
		{_input_options_i18n[index]}
	</Radio>
{/each}

<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequest}>
	{$format('button_save')}
</Button>
